import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { TableCellRoot, TableHeadCellRoot } from './TableCell.styled';
// Component.
// -----------------------------------------------------------------------------
const TableCell = forwardRef(({ children, header, text, align = 'left', ...rest }, ref) => {
    const Component = header ? TableHeadCellRoot : TableCellRoot;
    const Content = text || children;
    // Render.
    // -------------------------------------------------------------------------
    return (_jsx(Component, { ref: ref, align: align, ...rest, children: Content }));
});
// Component configuration.
// -----------------------------------------------------------------------------
TableCell.displayName = 'TableCell';
export default TableCell;
//# sourceMappingURL=TableCell.js.map